// extracted by mini-css-extract-plugin
module.exports = {"outer":"egM4_","heading":"_1vDVw","header":"_23dzJ","section":"_2kskG","atfTab":"yuL_V","activeTab":"_3DlbN"};